import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class AddToCartPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    section.addEventListener('change', this.#onSubscriptionChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    section.removeEventListener('change', this.#onSubscriptionChange);
  }

  /** @returns {HTMLElement | null} */
  #getTextWrapper() {
    return this.querySelector('.add-to-cart-text__content > span');
  }

  /** @returns {HTMLElement | null} */
  #getPriceSpan() {
    return this.querySelector('.add-to-cart-text__price');
  }

  /** @param {string} price - formatted price string e.g. "$75", or empty string to remove */
  #updatePrice(price) {
    const wrapper = this.#getTextWrapper();
    if (!wrapper) return;

    let priceSpan = this.#getPriceSpan();
    if (!price) {
      priceSpan?.remove();
      return;
    }
    if (!priceSpan) {
      priceSpan = document.createElement('span');
      priceSpan.className = 'add-to-cart-text__price';
      wrapper.appendChild(priceSpan);
    }
    priceSpan.dataset.price = price;
    priceSpan.textContent = ` • ${price}`;
  }

  #onVariantUpdate = (/** @type {any} */ event) => {
    const html = /** @type {Document | undefined} */ (event.detail.data.html);
    const newEl = html?.querySelector(`add-to-cart-price[data-block-id="${this.dataset.blockId}"]`);
    const newPriceSpan = newEl?.querySelector('.add-to-cart-text__price');
    this.#updatePrice(newPriceSpan?.dataset.price ?? '');
  };

  #onSubscriptionChange = (/** @type {Event} */ event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio' || !radio.dataset.sellingPlanId) return;
    this.#updatePrice(radio.dataset.price ?? '');
  };
}

if (!customElements.get('add-to-cart-price')) {
  customElements.define('add-to-cart-price', AddToCartPrice);
}
